import { gql } from '@apollo/client';

/**
 * GraphQL mutations for enhanced placeholders and deal field groups
 * Note: Team contact mutations are defined in contacts/ components to avoid duplicates
 */

// Deal Field Group Mutations
export const CREATE_DEAL_FIELD_GROUP = gql`
  mutation PlaceholdersCreateDealFieldGroup(
    $dealId: ID!
    $name: String!
    $slugRoot: String
    $slugAttr: String
    $slugIndex: Int
    $value: String
    $contactId: ID
    $contactField: String
  ) {
    createDealFieldGroup(
      dealId: $dealId
      name: $name
      slugRoot: $slugRoot
      slugAttr: $slugAttr
      slugIndex: $slugIndex
      value: $value
      contactId: $contactId
      contactField: $contactField
    ) {
      dealFieldGroup {
        id
        name
        slug
        value
        documentCount
        contactBinding
        boundContact {
          id
          name
        }
      }
      errors
    }
  }
`;

export const UPDATE_DEAL_FIELD_GROUP = gql`
  mutation PlaceholdersUpdateDealFieldGroup($id: ID!, $name: String, $value: String) {
    updateDealFieldGroup(id: $id, name: $name, value: $value) {
      dealFieldGroup {
        id
        name
        value
        documentCount
      }
      errors
    }
  }
`;

export const DELETE_DEAL_FIELD_GROUP = gql`
  mutation PlaceholdersDeleteDealFieldGroup($id: ID!) {
    deleteDealFieldGroup(id: $id) {
      success
      errors
    }
  }
`;

// Contact Binding Mutations
export const BIND_CONTACT_TO_FIELD_GROUP = gql`
  mutation PlaceholdersBindContactToFieldGroup($dealFieldGroupId: ID!, $contactId: ID, $contactField: String) {
    bindContactToFieldGroup(
      dealFieldGroupId: $dealFieldGroupId
      contactId: $contactId
      contactField: $contactField
    ) {
      dealFieldGroup {
        id
        value
        contactBinding
        boundContact {
          id
          name
          email
          phone
          company
        }
      }
      errors
    }
  }
`;

// Placeholder Linking Mutations
export const LINK_PLACEHOLDER_TO_FIELD_GROUP = gql`
  mutation PlaceholdersLinkToFieldGroup($placeholderLinkId: ID!, $dealFieldGroupId: ID!) {
    linkPlaceholderToFieldGroup(placeholderLinkId: $placeholderLinkId, dealFieldGroupId: $dealFieldGroupId) {
      documentPlaceholderLink {
        id
        currentValue
        lastSyncedAt
        dealFieldGroup {
          id
          name
          value
        }
      }
      errors
    }
  }
`;

export const UNLINK_PLACEHOLDER_FROM_FIELD_GROUP = gql`
  mutation PlaceholdersUnlinkFromFieldGroup($placeholderLinkId: ID!) {
    unlinkPlaceholderFromFieldGroup(placeholderLinkId: $placeholderLinkId) {
      documentPlaceholderLink {
        id
        currentValue
        dealFieldGroup {
          id
        }
      }
      errors
    }
  }
`;

// Update placeholder link value directly (for unlinked placeholders)
export const UPDATE_PLACEHOLDER_LINK_VALUE = gql`
  mutation PlaceholdersUpdateLinkValue(
    $placeholderUuid: ID!
    $linkableId: ID!
    $linkableType: String!
    $teamId: ID!
    $currentValue: String
  ) {
    updateDocumentPlaceholder(
      placeholderUuid: $placeholderUuid
      linkableId: $linkableId
      linkableType: $linkableType
      teamId: $teamId
      currentValue: $currentValue
    ) {
      id
      uuid
      status
    }
  }
`;

// Sync Mutation
export const SYNC_PLACEHOLDERS_ON_OPEN = gql`
  mutation PlaceholdersSyncOnOpen($documentId: ID!) {
    syncPlaceholdersOnOpen(documentId: $documentId) {
      synced
      updates {
        placeholderId
        newValue
        linkedGroupId
      }
      reason
    }
  }
`;
